export const environment = {
  production: true,
  enableDebug: false,
  appVersion: require('../../package.json').version,
  API_ENDPOINT: 'https://hungryforjob.com/hfj/',
  // API_ENDPOINT: 'http://43.204.32.67:7116/hfj/',
  siteKey:'6Lf8eF0lAAAAAPxJ0mufLBT8vR2XEyx6zt3Vl_7R'
};

